module.exports = __webpack_public_path__ + "img/jy.3cb59f07.jpeg";